/**
 * Function to correctly perform modulo for negative numbers.
 *
 * Source: https://stackoverflow.com/a/17323608
 */
export default function mod(n: number, m: number) {
  return ((n % m) + m) % m;
}
